import { CommonModule, JsonPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { SessionService } from '../../Util/Session/session.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { CommonService } from '../../Model/Common/common.service';
import { ForceCheckOutUtilityService } from '../../Model/ForceCheckOutUtility/force-check-out-utility.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';

@Component({
  selector: 'app-force-check-out-utility',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule, NgbDatepickerModule, JsonPipe],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './force-check-out-utility.component.html',
  styleUrl: './force-check-out-utility.component.scss'
})
export class ForceCheckOutUtilityComponent {
  dtTrigger: Subject<any> = new Subject<any>();
  public User: any = null;
  isDisabled: boolean = false;
  ForceCheckOutDate: any = null
  ForceDate : any = null
  BranchMaster: any[] = [];
  LogData : any[] = [];
  BranchMasterIDs: number[] = [];
  BranchName : string = ''
  BranchId : number = 0;
  dtoptions: DataTables.Settings = {};
  constructor(
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    protected common: CommonService,
    private forcecheckoututility : ForceCheckOutUtilityService,
    private tooltip: TooltipService,
    private dateFormate: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    const ids = this.BranchMasterIDs.join(',');
    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'Ids' : ids
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
          this.isDisabled = false
        }
        else if(Combotype == 'MultiplyIdsBranchDetails'){
          this.LogData =  response.ComboLoad;
          this.isDisabled = false
        }
      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
        this.isDisabled = false
      },
    });
  }


  CheckAll(event: any, Type: String) {
    if (Type == 'Branch') {
      if (event.target.checked) {
        this.BranchMasterIDs = this.BranchMaster.map((e: any) => e.BranchMasterID);
      } else {
        this.BranchMasterIDs = [];
      }
    }
  }

  Load(){
    this.User = this.sessionService.GetUserDetails();
    this.ForceCheckOutDate = this.dateFormate.format(this.ForceDate);
    if(this.ForceCheckOutDate == null || this.ForceCheckOutDate == ''){
      this.toast.show({ message: 'Please Select Date!', type: toastTypeEnum.warning });
      return
    }
    const ids = this.BranchMasterIDs.join(',');
    this.ComboLoad('MultiplyIdsBranchDetails');
  }
  
  async Save() {
  await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save?'
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsEdit) {
        if (result) {
         this.InsertUpdate();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }

  InsertUpdate() {
    this.User = this.sessionService.GetUserDetails();
    if (this.LogData.length === 0) {
      this.toast.show({ message: 'No Data Available!', type: toastTypeEnum.warning });
      return;
    }
    if (!this.ForceCheckOutDate) {
      this.toast.show({ message: 'Please Select Date!', type: toastTypeEnum.warning });
      return;
    }
    const selectedItems = this.LogData.filter(item => item.selected);
    if (selectedItems.length === 0) {
      this.toast.show({ message: 'Please select at least 1 branch!', type: toastTypeEnum.warning });
      return;
    }
    const branchIDs = selectedItems.map(item => item.BranchMasterID);
    const IDs = branchIDs.join(', ');
    const fordata = {
      SelectType: 'FRONT',
      BranchId: IDs,
      AttendanceDate: this.ForceCheckOutDate,
      By: this.User.UserId
    };
    this.isDisabled = true;
    this.forcecheckoututility.ForceCheckOutUtilityLogsUpdate(fordata).subscribe(
      data => {
        if (data.Error_Code === 359) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
        } else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false; 
      }
    );
  }
  
  // InsertUpdate() {
  //   this.User = this.sessionService.GetUserDetails();
  //   if (this.LogData.length === 0) {
  //     this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
  //     return
  //   }
  //   if(this.ForceCheckOutDate == null || this.ForceCheckOutDate == ''){
  //     this.toast.show({ message: 'Please Select Date!', type: toastTypeEnum.warning });
  //     return
  //   }
  //   this.User = this.sessionService.GetUserDetails();
  //   let branchIDs = this.LogData.map(item => item.BranchMasterID);
  //   let  IDs = branchIDs.join(', ');
  //   const fordata = {
  //     SelectType:  'FRONT',
  //     BranchId: IDs,
  //     AttendanceDate: this.ForceCheckOutDate,
  //     By : this.User.UserId
  //   };
  //   console.log('date',fordata);
  //   this.isDisabled =true
  //   this.forcecheckoututility.ForceCheckOutUtilityLogsUpdate(fordata).subscribe(
  //     data => {
  //       if (data.Error_Code == 359) {
  //         this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
  //       }
  //       else {
  //         this.toast.show({ message: data.Error_Message, type: toastTypeEnum.warning });
  //       }
  //        this.isDisabled = false;
  //     },
  //     error => {
  //       console.error('Error:', error);
  //     });
  // }

  // deleteRow(index: number): void {
  //   this.LogData.splice(index, 1);
  // }

  onSelectChange(type: string) {
    if (type === 'Branch') {
      const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
      this.BranchName = selected ? selected.BranchName : null;
    }
  }

  selectAll(event: any) {
    const checked = event.target.checked;
    this.LogData.forEach(shift => shift.selected = checked);
  }
  selectRow(event: any, shift: any) {
    shift.selected = event.target.checked;
  }

  clear(){
    this.LogData = [];    
  }
}
